export default "__VITE_ASSET__CDt6kFUP__"